var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.Seleccionado)?_c('div',[_c('Cartilla',{attrs:{"id_plan":_vm.Seleccionado.id_plan}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }